<!--    
    The sliders etc for Alarms and the save Button. Only Hydranten for now??   
    Maybe split the possible alarms depending on wether they are a Boolean:
        Boolean:  Möglichkeiten sind Bool1 Bool0
        Not Boolean: Möglichkeiten = Eingabe Felder für Min bzw Max. Beide setzbar in einem Alarm!


-->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { selected_device, toast_message } from "../stores.js";
    import VehicleAlarmAuswahlElement from "./VehicleAlarmAuswahlElement.svelte";
    import { BASE_API_URL } from "../config.js";
    import { user_role } from "../scripts/auth.js";

    export let all_vehicles;
    export let is_disabled = false;

    let channels_copy = []; // Copy of the channels to save the changes

    // creates a copy of the channels to save the changes. If no alarm is given, a new alarm is created
    // Alarme für Non Bools ändern
    $: {
        // creating copy of the channels so we can save (or reset) changes
        if ($selected_device) {
            create_channel_list();
        }
    }

    function create_channel_list() {
        if (!$selected_device.device.channel_set) {
            channels_copy = [];
        } else {
            channels_copy = [];
            channels_copy = JSON.parse(
                JSON.stringify($selected_device.device.channel_set),
            );
        }

        channels_copy.forEach((channel) => {
            if (!channel.alarm_set || channel.alarm_set.length == 0) {
                channel.alarm_set = [];
                let alarm = {
                    id: null,
                    channel: channel.id,
                    min_alarm_active: 0,
                    max_alarm_active: 0,
                    autoquit: 1,
                };
                channel.alarm_set.push(alarm);
            }
        });
    }
    async function handle_alarms() {
        set_timeout_button();

        try {
            channels_copy.forEach((channel) => {
                if (channel.alarm_set[0].id == null) {
                    create_alarm(channel.alarm_set[0]);
                } else {
                    update_alarm(channel.alarm_set[0]);
                }
            });
            $toast_message = "Alarme gespeichert";
        } catch (error) {
            console.error("Error handling alarms:", error);
        }
    }

    async function update_alarm(alarm) {
        let url_extension = `/vehicles/${$selected_device.device.id}/alarms/${alarm.id}/`;
        let request_url = BASE_API_URL + url_extension;

        try {
            const response = await fetch(request_url, {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(alarm),
            });
            if (response.status === 200) {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    async function create_alarm(alarm) {
        let url_extension = `/vehicles/${$selected_device.device.id}/alarms/`;
        let request_url = BASE_API_URL + url_extension;

        try {
            const response = await fetch(request_url, {
                method: "POST",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(alarm),
            });
            if (response.status === 201) {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    let is_button_disabled = false;
    function set_timeout_button() {
        is_button_disabled = true;
        setTimeout(() => {
            is_button_disabled = false;
        }, 500);
    }
</script>

<div id="sensor_grenzwerte">
    {#each channels_copy as channel (channel.id)}
        <VehicleAlarmAuswahlElement bind:channel />
    {/each}
</div>

{#if $user_role["set_alarm"] && $user_role["set_alarm"] == 1}
    <div class="input-group mb-2 mt-4">
        <!-- <button
            class="btn btn-secondary btn-block "
            disabled={is_button_disabled}
        >
            Standard Grenzwerte bearbeiten
        </button> -->
    </div>

    <div class="input-group mb-2 mt-4">
        <button
            class="btn btn-primary btn-block"
            id="save_grenzwerte"
            disabled={is_button_disabled || channels_copy.length == 0}
            on:click={() => handle_alarms()}
        >
            Speichern
        </button>
    </div>
{/if}
